(function () {
  const ui = document.getElementById('flavour-ui');
  if (!ui || ui.dataset.flvInitialized === '1') return; // idempotent
  ui.dataset.flvInitialized = '1';

  // One controller to cleanly bind events once
  const ac = new AbortController();
  const on = (el, evt, fn, opts) => el && el.addEventListener(evt, fn, {signal: ac.signal, ...(opts||{})});

  // Scope queries to the snippet’s parent so it sees the modal too
  const root = ui.parentElement || document;

  // ---- Limits (robust JSON parse + fallback) -------------------------------
  const parseJsonSafe = (s, fb) => { try { return JSON.parse(s); } catch { return fb; } };
  const limits = parseJsonSafe(ui.getAttribute('data-limits'), {"250":3,"500":6,"1000":10});

  // ---- Elements (defensive) -------------------------------------------------
  const modal        = root.querySelector('[data-flv-modal]');
  const grid         = modal?.querySelector('[data-flv-grid]') || null;
  const limitTextEl  = modal?.querySelector('[data-flv-limit-text]') || null;
  const openBtn      = ui.querySelector('[data-open-flavour-modal]');
  const summarySpan  = ui.querySelector('[data-flv-summary]');
  const summaryInput = ui.querySelector('[data-flv-summary-input]');
  const statusCntEls = root.querySelectorAll('[data-flv-count]');
  const statusLimEls = root.querySelectorAll('[data-flv-limit]');

  const hiddenWeightInput = root.querySelector('.disclosure--input[data-option-name="weight"]');

  // Helpers
  const getChecks   = () => grid ? Array.from(grid.querySelectorAll('.flv-check')) : [];
  const getSelected = () => getChecks().filter(c => c.checked && !c.disabled);

  function norm(t){ return (t||'').toString().toLowerCase().replace(/\s+/g,'').trim(); }

  function getCurrentWeightLabel() {
    // 1) Hidden input value (theme-updated)
    const v1 = hiddenWeightInput?.value;
    if (v1) return v1;

    // 2) Selected <li>
    const li = root.querySelector('.disclosure--form .disclosure--option[aria-current="true"][data-option-name="weight"]');
    if (li) return li.getAttribute('data-value') || li.textContent || '';

    // 3) Visible toggle text
    const cur = root.querySelector('.disclosure--current-option');
    return cur?.textContent || '';
  }

  function gramsFromLabel(labelRaw) {
    const label = norm(labelRaw);
    if (!label) return 250;

    // Direct contains
    if (label.includes('1kg') || label.includes('1000g') || label === '1000' || /(^|[^0-9])1000([^0-9]|$)/.test(label)) return 1000;
    if (label.includes('500g') || label === '500'   || /(^|[^0-9])500([^0-9]|$)/.test(label))  return 500;
    if (label.includes('250g') || label === '250'   || /(^|[^0-9])250([^0-9]|$)/.test(label))  return 250;

    // Free-form “1 kg”, “750 g”, etc.
    const m = label.match(/(\d+(?:\.\d+)?)(kg|g)?/);
    if (m) {
      let n = parseFloat(m[1]);
      const unit = (m[2]||'g').toLowerCase();
      if (unit === 'kg') n = n * 1000;
      return Math.round(n);
    }
    return 250;
  }

  function computeLimit() {
    const grams = gramsFromLabel(getCurrentWeightLabel());
    if (grams >= 1000 && limits['1000']) return limits['1000'];
    if (grams >= 500  && grams < 1000 && limits['500'])  return limits['500'];
    if (grams >= 250  && grams < 500  && limits['250'])  return limits['250'];
    return limits['250'] ?? Object.values(limits)[0] ?? 3;
  }

  function updateLimitUI() {
    const lim = computeLimit();
    statusLimEls.forEach(el => (el.textContent = lim));
    if (limitTextEl) limitTextEl.textContent = `Choose up to ${lim} flavours for this weight.`;
    return lim;
  }

  function enforceLimit() {
    const lim = updateLimitUI();
    const checks = getChecks();
    const selected = getSelected();
    const count = selected.length;

    // Soft-disable unchecked boxes when cap reached, but keep disabled meta for "is-disabled" cards
    checks.forEach(c => {
      if (!c.checked) {
        const softDisabled = c.closest('.flv-card')?.classList.contains('is-disabled');
        c.disabled = (count >= lim) || !!softDisabled;
      }
    });

    // Sync counters (inline + modal)
    statusCntEls.forEach(el => (el.textContent = count));

    // Summary
    const names = selected.map(c => c.value);
    if (summaryInput) summaryInput.value = names.join(', ');
    if (summarySpan)  summarySpan.textContent = names.length ? `— ${names.join(', ')}` : '— none selected';
  }

  function clearSelectionAndEnforce() {
    getChecks().forEach(c => (c.checked = false));
    enforceLimit();
  }

  // ---- Modal open/close (defensive) ----------------------------------------
  function openModal() {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('flv-noscroll');
    document.body.classList.add('flavours-modal-active');
    enforceLimit();
  }
  function closeModal() {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('flv-noscroll');
    document.body.classList.remove('flavours-modal-active');
  }

  on(document, 'keydown', (e) => {
    if (e.key === 'Escape' && modal?.getAttribute('aria-hidden') === 'false') closeModal();
  });

  on(openBtn, 'click', openModal);

  if (modal) {
    modal.querySelectorAll('[data-flv-close], .flv-modal__backdrop')
      .forEach(el => on(el, 'click', closeModal));

    const applyBtn = modal.querySelector('[data-flv-apply]');
    const clearBtn = modal.querySelector('[data-flv-clear]');
    on(applyBtn, 'click', () => { enforceLimit(); closeModal(); });
    on(clearBtn, 'click', clearSelectionAndEnforce);

    // Event delegation for all flavour checkboxes in the grid
    on(modal, 'change', (e) => {
      const t = e.target;
      if (t && t.classList && t.classList.contains('flv-check')) enforceLimit();
    });

    // If theme re-renders the grid, re-enforce right away
    const gridObserver = new MutationObserver(() => enforceLimit());
    grid && gridObserver.observe(grid, {childList: true, subtree: true});
  }

  // ---- Weight change hooks (robust) ----------------------------------------
  // Click on weight option <li>
  on(root, 'click', (e) => {
    const li = e.target.closest?.('.disclosure--option[data-option-name="weight"]');
    if (!li) return;
    // Wait a tick so theme updates aria/current + hidden input
    requestAnimationFrame(() => { clearSelectionAndEnforce(); });
  });

  // Observe hidden input value changes
  if (hiddenWeightInput) {
    const mo = new MutationObserver(() => clearSelectionAndEnforce());
    mo.observe(hiddenWeightInput, { attributes: true, attributeFilter: ['value'] });
  }

  // Fallback custom events (various themes)
  on(document, 'variant:change', clearSelectionAndEnforce);
  on(document, 'product:variant-change', clearSelectionAndEnforce);

  // ---- Submit: one hidden "Flavours" per selected, + keep summary input ----
  const form = ui.closest('form[action^="/cart/add"]') || root.querySelector('form[action^="/cart/add"]');
  if (form) {
    on(form, 'submit', () => {
      // Remove previous properties[Flavours]
      let selectedFlavours = Array.from(grid.querySelectorAll('.flv-check')).filter(c => c.checked && !c.disabled).map(c => c.value);
      console.log(selectedFlavours)
      form.querySelectorAll('input[name="properties[Flavours]"]').forEach(n => n.remove());
      const n = document.createElement('input');
      n.type = 'hidden';
      n.name = 'properties[Flavours]';
      n.value = selectedFlavours.join(', ');
      form.appendChild(n);
      // Keep the single summary input in sync for display/debug (optional)
      if (summaryInput) summaryInput.value = selectedFlavours.join(', ');
    });
  }

  // ---- Initial settle (after DOM paints) -----------------------------------
  // Two rAFs give the theme a moment to render late elements
  requestAnimationFrame(() => requestAnimationFrame(enforceLimit));

  // ===================== Covering UI (robust) ================================
  (function () {
    const cov = document.getElementById('covering-ui');
    if (!cov) return;

    const covError = cov.querySelector('[data-cv-error]');
    const covRadios = () => Array.from(cov.querySelectorAll('input[name="properties[Covering]"]'));
    const form2 = form || ui.closest('form[action^="/cart/add"]') || root.querySelector('form[action^="/cart/add"]');

    const flavourCount = () => getSelected().length;

    function toggleCoveringUI() {
      const show = flavourCount() > 0;
      cov.hidden = !show;
      if (!show) {
        covRadios().forEach(r => (r.checked = false));
        if (covError) covError.hidden = true;
      }
    }

    // Any flavour change (delegated above) will call enforceLimit, but we also toggle here
    on(root, 'change', (e) => {
      const t = e.target;
      if (t && t.classList && t.classList.contains('flv-check')) toggleCoveringUI();
    });

    on(document, 'variant:change', toggleCoveringUI);
    on(document, 'product:variant-change', toggleCoveringUI);

    // Guard on submit: require a covering if visible
    if (form2) {
      on(form2, 'submit', (e) => {
        if (cov.hidden) return;
        const picked = cov.querySelector('input[name="properties[Covering]"]:checked');
        if (!picked) {
          e.preventDefault();
          if (covError) covError.hidden = false;
          cov.scrollIntoView({behavior:'smooth', block:'center'});
        } else if (covError) {
          covError.hidden = true;
        }
      });
    }

    // Initial state
    toggleCoveringUI();
  })();

})();